<div class="zeva-page">
  <router-outlet #o="outlet"></router-outlet>
  <core-footer />
</div>
